export default "__VITE_ASSET__BPjpgsa1__"